/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';

const is = require('is_js');

export class UploadDocService {
  private static instance: UploadDocService;
  private vapp: VApplication;
  private readonly uploadAPI: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.uploadAPI = props?.uploadAPI;
  }

  public static getInstance(props: any = {}): UploadDocService {
    if (!UploadDocService.instance) {
      UploadDocService.instance = new UploadDocService(props);
    }
    return UploadDocService.instance;
  }

  public async uploadDoc(args: any) {
    let _args = {
      doc: args,
      apiURL: this.uploadAPI,
    };
    let content: any = {};
    const agent = getAgent();

    return agent.uploadDoc(_args);
  }
}
